/**
 * UI constants for coach pages — sport/segment display config.
 * Extracted from mock so pages can drop the mock import entirely.
 */

export type SportType = 'running' | 'cycling' | 'swimming' | 'strength' | 'crossfit' | 'hyrox' | 'walking' | 'hiking' | 'multi-sport';
export type DifficultyLevel = 'beginner' | 'intermediate' | 'advanced' | 'elite';
export type SegmentType = 'warmup' | 'main' | 'cooldown' | 'strength' | 'mobility';
export type DayOfWeek = 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';

export const sportConfig: Record<SportType, { label: string; color: string }> = {
  running: { label: 'Running', color: 'hsl(200 65% 55%)' },
  cycling: { label: 'Cycling', color: 'hsl(35 85% 55%)' },
  swimming: { label: 'Swimming', color: 'hsl(190 70% 50%)' },
  strength: { label: 'Strength', color: 'hsl(0 70% 55%)' },
  crossfit: { label: 'CrossFit', color: 'hsl(280 55% 55%)' },
  hyrox: { label: 'Hyrox', color: 'hsl(150 55% 50%)' },
  walking: { label: 'Walking', color: 'hsl(160 45% 55%)' },
  hiking: { label: 'Hiking', color: 'hsl(95 50% 45%)' },
  'multi-sport': { label: 'Multi-Sport', color: 'hsl(220 60% 55%)' },
};

export const segmentTypeConfig: Record<SegmentType, { label: string; color: string }> = {
  warmup: { label: 'Warm Up', color: 'hsl(150 55% 50%)' },
  main: { label: 'Main Set', color: 'hsl(200 65% 55%)' },
  cooldown: { label: 'Cool Down', color: 'hsl(220 40% 50%)' },
  strength: { label: 'Strength', color: 'hsl(0 70% 55%)' },
  mobility: { label: 'Mobility', color: 'hsl(280 55% 55%)' },
};
